<template>
    <base-modal :value="value" @input="canceled" backdrop="static" body-classes="p-0">
        <card type="secondary"
            header-classes="bg-transparent"
            body-classes="px-lg-4 py-lg-4"
            class="border-0 mb-0">

            <div class="mb-3">
                <h6 class="modal-title">
                    {{ $t('import.check-file') }}
                </h6>
                <button type="button"
                        class="close"
                        @click="value.show=false"
                        data-dismiss="modal"
                        aria-label="Close">
                    <span>×</span>
                </button>
            </div>

            <p>{{ $t(type + '.import-description') }}</p>

            <div class="dropzone">
                <dropzone
                    v-model="file"
                    :url="endpoint"
                    :options="options"
                    @addedfile="addedFile"
                    @error="error"
                    @complete="complete"
                    @success="success"
                ></dropzone>
            </div>

            <div class="text-center text-success mb-3" v-if="passed">
                <i class="display-1 fas fa-check"></i>
            </div>

            <div class="text-center text-danger mb-3" v-if="errorFound">
                <small class="font-weight-bold">{{ $t('import.error') }}</small>
            </div>

            <div class="text-center">
                <base-button type="primary" @click="upload" :loading="uploading" v-if="readyToUpload">
                    {{ $t('import.check') }}
                </base-button>
            </div>
        </card>
    </base-modal>
</template>

<script>
    export default {
        
        props: {

            value: {
                type: Object,
                required: true
            },

            type: {
                type: String,
                required: true
            }
        },
        
        data() {
            return {
                endpoint: this.$baseURL + '/socrates/api/front/' + this.type + '/import/check',
                options: {
                    autoProcessQueue: false,
                    acceptedFiles: '.csv',
                },
                file: null,
                dropzone: null,
                readyToUpload: false,
                uploading: false,
                errorFound: false,
                passed: false,
            }
        },

        watch: {
            value(val) {
                if (val.show) {
                    this.reset()
                    // Scroll to the top of the modal when reopened.
                    this.$nextTick(() => {
                        this.$el.scrollTop = 0
                    })
                }
            }
        },

        methods: {

            canceled() {
                this.$emit('input', {
                    id: this.value.id,
                    show: false,
                    changed: false,
                })
            },

            reset() {
                this.errorFound = false
                this.passed = false
            },

            addedFile(event) {
                this.dropzone = event.dropzone
                this.reset()
                this.readyToUpload = true
            },

            upload() {
                this.reset()
                this.uploading = true
                this.dropzone.processQueue()
            },

            complete(event) {
                this.uploading = false
                this.readyToUpload = false
            },

            error(event) {
                let xhr = event.args[2]
                if (xhr.status == 400) {
                    // Validation error.
                    this.$emit('input', {
                        id: this.value.id,
                        show: false,
                        changed: true,
                    })
                } else {
                    // Othe error.
                    this.errorFound = true
                }
            },

            success(event) {
                this.file = null
                this.dropzone.removeAllFiles()
                this.passed = true
                if (this.type == 'users') {
                    this.$emit('input', {
                        id: this.value.id,
                        show: false,
                        changed: true,
                    })
                }
            },
        }
    }
</script>

<style scoped>

    .modal-title {
        text-transform: uppercase;
    }
    button.close {
        padding-right: 1rem;
        margin: -1rem -1rem -1rem auto;
    }
    .dropzone >>> .dropzone-single.dz-max-files-reached .dz-message {
        background-color: #ffffff !important;
        color: #8898aa !important;
        opacity: 1 !important;
        border: 2px solid #2dce89;
    }

</style>